import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { PRIMARY_ORANGE } from "./constants";

export const PageBreadcrumbs = ({ breadcrumbs = [] }) => {
  if (breadcrumbs.length === 0) return null;

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1.5 }}>
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        if (crumb.to && !isLast) {
          return (
            <Link
              key={`${crumb.label}-${index}`}
              component={RouterLink}
              to={crumb.to}
              underline="hover"
              sx={{ color: "text.secondary", fontSize: "0.875rem" }}
            >
              {crumb.label}
            </Link>
          );
        }
        return (
          <Typography
            key={`${crumb.label}-${index}`}
            sx={{
              color: isLast ? PRIMARY_ORANGE : "text.secondary",
              fontSize: "0.875rem",
              fontWeight: isLast ? 500 : 400,
            }}
          >
            {crumb.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

export const PageTitleBlock = ({ title, subtitle }) => (
  <Box className="page-title-block">
    <Typography variant="h5" sx={{ fontWeight: 700, color: "#1a1a1a", mb: 0.5, lineHeight: 1.2 }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.4 }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

const PageHeader = ({ breadcrumbs = [], title, subtitle }) => (
  <Box className="page-header" sx={{ mb: 2 }}>
    <PageBreadcrumbs breadcrumbs={breadcrumbs} />
    <PageTitleBlock title={title} subtitle={subtitle} />
  </Box>
);

export default PageHeader;
